import {NavigationStart, Router, RoutesRecognized} from '@angular/router';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {Component} from '@angular/core';
import {InformationBarActions} from '../core/reducers/informationBar.actions';
import {TranslateService} from '@ngx-translate/core';
import {AuthClient} from '../auth/auth.client';
import {RestApi} from '../auth/rest.api';
import {AppDataService} from '../app.data.service';
import {EnvironmentActions} from '../core/reducers/environment.actions';
import {CustomPropertiesInformationBar} from '../core/models/customPropertiesInformationBar';
import {EmptyComponent} from '../shared/components/empty/empty.component';
import {ViewerEntriesReloadComponent} from '../trace-management/viewer/reload/viewer-reload-entries.component';
import {EventLogMenuComponent} from '../event-log/event.log.menu/event.log.menu.component';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'management-console',
  templateUrl: 'management-console.component.html',
  styleUrls: ['management-console.component.scss']
})
export class ManagementConsoleComponent {
   public authenticated = true;
  public displayContent = false;
  private expandedState;
  private expandedStateWide;
  private subscription: Subscription;
  private customPropertiesinformationBar: ICustomPropertiesInformationBar;
  private componentData: any;
  private isVisibleBack = false;
  private widthScreen: any;
  private loading;
  private queryParams: { [key: string]: any };

  constructor(
    private _router: Router,
    private _store: Store<IAppState>,
    private _informationBarActions: InformationBarActions,
    private _authClient: AuthClient,
    protected api: RestApi,
    private _appDataService: AppDataService,
    private _environmentActions: EnvironmentActions) {
    this.componentData = null;
  }

  public ngOnInit() {

    // Subscribe to a service that change when authentication state changes
    this._authClient.isAuthenticatedAsync().subscribe((authenticated) => {
      this.authenticated = authenticated;
      if (this.authenticated) {
        this._appDataService.setLoader(true);
        this._appDataService.getCurrentEnvironment().subscribe(environment => {
          this._appDataService.setLoader(false);
          this._store.dispatch(this._environmentActions.Add(environment.Current));
          sessionStorage.setItem('environmentType', environment.Current);
        });
      }
    });

    // this.displayContent = this.authTokenManager.getDisplayContent();
    this.customPropertiesinformationBar = new CustomPropertiesInformationBar();


    this.setSliderBehaviour();

    // this._router.navigate(['/Dashboard']);

    this.subscription = this._router.events.subscribe((event: any) => {
      if (event instanceof RoutesRecognized) {
        // let tempCustomPropertiesInformationBar: ICustomPropertiesInformationBar =
        //   event.state.root.firstChild.firstChild.data['customPropertiesinformationBar'];
        // console.log(this.route.snapshot.data);

        // this._store
        //   .select((s) => s.informationBarState.customPropertiesInformationBar)
        //   .subscribe((value: any) => {
        //     this.customPropertiesinformationBar.firstLevelInformation =
        //       (typeof value.firstLevelInformation === 'string' &&
        //         value.firstLevelInformation !== '') ?
        //         value.firstLevelInformation : sessionStorage.getItem('environmentType');
        //     this.customPropertiesinformationBar.secondLevelInformation =
        //       value.secondLevelInformation;
        //   });

        this._store.select((s) => s.informationBarState.customPropertiesInformationBar)
          .subscribe((value: any) => {
            const updatedProperties = {...value,
              firstLevelInformation: (typeof value.firstLevelInformation === 'string' && value.firstLevelInformation !== '') ?
                value.firstLevelInformation : sessionStorage.getItem('environmentType'),
              secondLevelInformation: value.secondLevelInformation
            };
          this.customPropertiesinformationBar = updatedProperties;
        });

        this._store
          .select((s) => s.environmentState.environment)
          .subscribe((environment: string) => {
            this.customPropertiesinformationBar.firstLevelInformation = (environment) ? environment : '...';
            // this.customPropertiesinformationBar.secondLevelInformation = tempCustomPropertiesInformationBar.secondLevelInformation;
            this._store.dispatch(this._informationBarActions.Add(this.customPropertiesinformationBar));

          });

      }
      if (event instanceof NavigationStart) {
        this.loadDynamicComponent(event.url);
      }

    });
  };

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private loadDynamicComponent(currentRoute: string) {
    this.isVisibleBack = false;
    if (currentRoute.indexOf('/Tracing/children') > -1) {
      this.isVisibleBack = true;
      this.componentData = {
        component: EmptyComponent,
        inputs: {}
      };
    } else if (currentRoute.indexOf('/Tracing/viewer') > -1) {
      this.isVisibleBack = true;
      this.componentData = {
        component: ViewerEntriesReloadComponent,
        inputs: {
          search: true,
          menu: true
        }
      };
    } else if (currentRoute.indexOf('/Tracing') > -1) {
      this.isVisibleBack = false;
      this.componentData = {
        component: ViewerEntriesReloadComponent,
        inputs: {
          search: true,
          menu: true
        }
      };
    } else if (currentRoute.indexOf('/EventsLog') > -1) {
      this.componentData = {
        component: EventLogMenuComponent,
        inputs: {
          search: true,
          menu: true
        }
      };
    } else if (currentRoute.indexOf('/Deployment') > -1) {
      this.componentData = {
        component: EmptyComponent,
        inputs: {
          search: true,
          menu: true
        }
      };
    } else if (currentRoute.indexOf('/Maintenance') > -1) {
      this.componentData = {
        component: EmptyComponent,
        inputs: {
          search: true,
          menu: true
        }
      };
    } else {
      this.componentData = {
        component: EmptyComponent,
        inputs: {}
      };
    }
  }



  // =====Slide Methods=====

  private onResize(event) {
    this.setSliderBehaviour();
  }

  private setSliderBehaviour() {
    if (this.hasNotChangedSized()) {
      return;
    }

    const breakLarge = 1024; // px
    this.widthScreen = window.innerWidth;
    if (window.innerWidth >= breakLarge) // wideScreens
    {
      this.expandedState = '';
      this.expandedStateWide = 'expanded';
    } else {
      this.expandedState = 'expanded';
      this.expandedStateWide = '';
    }
  }

  private hasNotChangedSized() {
    const previousWidth = 1024 - this.widthScreen;
    const currentWidth = 1024 - window.innerWidth;
    return (previousWidth <= 0 && currentWidth <= 0) || (previousWidth > 0 && currentWidth > 0);
  }

  public toggleMobileSlider(e, origin) {
    if (origin === 'sliderContent' && this.expandedState === 'collapsed') {
      this.expandedState = 'expanded';
    }
    if (origin === 'btnNav') {
      this.expandedState = this.expandedState === 'expanded' ? 'collapsed' : 'expanded';
    }
    e.stopPropagation();
  };

  private toggleSlider() {
    this.expandedStateWide = this.expandedStateWide === 'expanded' ? 'collapsed' : 'expanded';
  }

  public onItemNavigationClicked() {
    if (this.widthScreen < 1024) { // mobile view
      this.expandedState = 'expanded';
    }
  };


}
